export * as fragments from './fragments'
export * as mutations from './mutations'
export * as queries from './queries'
export * as inputs from './inputs'
